import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";
import { useLocalizedSettings } from "@/lib/localizedSettings";
import { useT } from "@/lib/i18n";
import BrandName from "@/components/BrandName";

export default function Footer() {
  const s = useLocalizedSettings();
  const t = useT();
  return (
    <footer
      id="kontakt"
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#09090B] px-6 py-16 lg:px-10"
    >
      <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <BrandName
            name={s.workshop_name}
            size="lg"
            testId="footer-brand"
          />
          <p className="mono mt-4 text-[11px] uppercase tracking-[0.2em] text-white/40">
            {s.tagline}
          </p>
          <p className="mt-6 max-w-md text-sm text-white/60">{s.footer_note}</p>
        </div>

        <div>
          <h4 className="mono mb-4 text-[11px] uppercase tracking-[0.2em] text-[#FF4B00]">
            {t("footer.contact")}
          </h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>{s.address_line1}</li>
            <li>{s.address_line2}</li>
            <li className="pt-2">
              <span className="mono text-white">{s.phone}</span>
            </li>
            <li className="mono text-white/60">{s.email}</li>
          </ul>
        </div>

        <div>
          <h4 className="mono mb-4 text-[11px] uppercase tracking-[0.2em] text-[#FF4B00]">
            {t("footer.hours")}
          </h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex justify-between">
              <span>{t("footer.mon_sat")}</span>
              <span className="mono text-white">{s.hours_weekdays}</span>
            </li>
            <li className="flex justify-between">
              <span>{t("footer.sunday")}</span>
              <span className="mono text-white/50">{s.hours_sunday}</span>
            </li>
          </ul>
          {s.instagram_handle && (
            <a
              href={`https://instagram.com/${s.instagram_handle}`}
              target="_blank"
              rel="noreferrer"
              className="mono mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-white/60 hover:text-[#FF4B00]"
            >
              @{s.instagram_handle}
            </a>
          )}
        </div>
      </div>

      <div className="mx-auto mt-16 flex max-w-7xl items-center justify-between border-t border-white/10 pt-6">
        <p
          data-testid="footer-copyright"
          className="mono text-[10px] uppercase tracking-[0.2em] text-white/40"
        >
          {s.copyright_text || `© 2026 ${s.workshop_name} · Alle Rechte vorbehalten`}
        </p>
        <div className="flex items-center gap-6">
          <Link
            to="/impressum"
            data-testid="footer-impressum-link"
            className="mono text-[10px] uppercase tracking-[0.2em] text-white/40 transition-colors hover:text-[#FF4B00]"
          >
            {t("footer.impressum")}
          </Link>
          <Link
            to="/admin/login"
            data-testid="admin-login-link"
            className="mono text-[10px] uppercase tracking-[0.2em] text-white/40 transition-colors hover:text-[#FF4B00]"
          >
            {t("footer.admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
